import { api } from '../../../api/api'
import { LoginResponse } from '../../../api/authentication/auth'
import { API_URL_LOG_IN } from '../../../api/constants'

export const logIn = async ({ ...values }): Promise<LoginResponse> => {
  const apiReturn: Promise<LoginResponse> = api
    .noAuth()
    .url(`${API_URL_LOG_IN}`)
    .options({ credentials: 'include', mode: 'cors' })
    .post({ ...values })
    .json()
  return apiReturn
}
